import styled from 'styled-components'

export const IconWrapper = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
`
